import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/vendor-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/VendorForm';
import { IVendor } from 'src/types/vendor';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    vendor: IVendor | null;
    files: any;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getFiles: (id: string | number) => void;
    addFiles: (id: string | number, files: any) => void;
    removeFile: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const VendorEditScreen: FC<Props> = (props: Props) => {
    const {
        vendor,
        match: {
            params: { id },
        },
        getFiles,
        files,
        addFiles,
        removeFile,
        inProgress,
        getData,
    } = props;

    useEffect(() => {
        if (!vendor || vendor.id !== id) {
            getData(id);
            getFiles(id);
        }
        // eslint-disable-next-line
    }, [getFiles, getData, id]);

    const handeAdd = (files: any) => {
        addFiles(id, files);
    };
    const handeRemove = (fileId: string | number) => {
        removeFile(fileId);
    };

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'VENDORS', path: routes.VENDORS_LIST },
                    { name: `EDIT ${vendor?.name ? vendor?.name : ''}`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                {inProgress ? <Loader /> : !vendor ? <div></div> : null}
                <Form
                    files={files ? files : []}
                    setFiles={handeAdd}
                    removeFile={(id) => handeRemove(id)}
                    initialValues={{ ...vendor }}
                />
            </div>
        </AdminLayout>
    );
};
export default VendorEditScreen;
